import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom'
import {
  Typography, Box, CircularProgress, useTheme
} from '@mui/material';

import { notificationActions, qrActions } from "../../store/actions";
import { coreFunctions, IsDevice } from "../../utils";
import { GenericContainerCenter, GenericContainer } from "../../components";
// import { mainStyles, theme } from '../../styles'
import { useStyles } from "./QrCodeStyle";
import packageJson from "../../../package.json";

export default function QrCodeComponent(props) {
  const gridContainer = {} //mainStyles.gridStyle();
  const localStyles = useStyles();
  const [qrCode, setQrCode] = useState(null);
  const [uidCode, setUidCode] = useState("");
  const [transitionView, setTransitionView] = useState(false);
  const [start, setstartProcess] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const qrUID = useSelector((state) => state.QrUid);
  const qrImage = useSelector((state) => state.QrImage);
  const qrUidData = useSelector((state) => state.QrUidData);
  const qrFile = useSelector((state) => state.AssociatedFile);

  useEffect(() => {
    sessionStorage.clear();
    sessionStorage.setItem(
      "token",
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InVzcmFnZW50ZTEiLCJuYW1laWQiOiIxNDkiLCJuYmYiOjE2NTE1OTM2NTksImV4cCI6MTY2MDU5MzY1OSwiaWF0IjoxNjUxNTkzNjU5LCJpc3MiOiJBdXRlbnRpY2FjaW9uT25Cb2FyZGluZ1NlcnZpY2UiLCJhdWQiOiJEZWZhdWx0QXVkaWVuY2UifQ.0ZJ8WqF843Lix9nX_O7yPwfQFEo0J_MslGpdaaRiE_g"
    );

    // /* let folioId = 200121 */
    // let folioId = 200214  
    // let qrProcess = true
    // let nextComponent = coreFunctions.GetLegoNext("Carga documental")
    // qrCodeFunctions.nextStage({ navigate, nextComponent, folioId, qrProcess })

    // /* let folioId = 200121 */
    // let folioId = 200143
    // let qrProcess = true
    // let nextComponent = coreFunctions.GetLegoNext("Carga documental")
    // qrCodeFunctions.nextStage({ navigate, nextComponent, folioId, qrProcess })

    dispatch(qrActions.GetQrUid(''))
    setstartProcess(true)
    console.log('qrCode', qrCode)
  }, [])

  /* useEffect(() => {
      sessionStorage.clear()
      dispatch(qrActions.GetQrUid(''))
      setstartProcess(true)
      console.log('qrCode', qrCode)
  }, []) */

  useEffect(() => {
    if (qrUID.items != undefined && qrUID.items?.Code != null && start) {
      console.log("qrUID.items.Code: ", qrUID.items.Code)
      dispatch(notificationActions.GetQrImage(qrUID.items.Code));
      setUidCode(qrUID.items.Code);
    }
  }, [qrUID]);

  useEffect(() => {
    if (qrImage.itemsURL != undefined && uidCode != "") {
      setQrCode(qrImage.itemsURL);
      dispatch(
        qrActions.GetQrUidData({
          QRUID: uidCode,
        })
      );
    }
  }, [qrImage]);

  useEffect(() => {
    if (qrUidData.items != undefined && qrCode != null) {
      if (qrUidData.items?.AssociationToken != null) {
        sessionStorage.setItem("token", qrUidData.items.AssociationToken);
        setTransitionView(true);
      } else {
        setTimeout(() => {
          dispatch(
            qrActions.GetQrUidData({
              QRUID: uidCode,
            })
          );
        }, 3000);
      }
    }
  }, [qrUidData]);

  useEffect(() => {
    if (transitionView) {
      dispatch(
        qrActions.GetAssociatedFile({
          QRUID: uidCode,
        })
      );
    }
  }, [transitionView]);

  useEffect(() => {
    if (
      qrFile.items != undefined &&
      qrFile.items?.FileData != undefined &&
      qrCode != null
    ) {
      console.log("llega al envio");
      let stage = qrFile.items.FileData.Stage;
      let stageId = stage.Id;
      let stageName = stage.Name;
      let folioId = qrFile.items.FileData.Id;
      let qrProcess = true;
      let nextComponent = coreFunctions.GetLegoNext(stageName);
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, qrProcess } })
    }
  }, [qrFile]);

  return (
    <GenericContainer>
      <GenericContainerCenter>
        <Typography variant="h6">
          Escanear código QR
        </Typography>
        <Typography variant="subtitle2">
          Para realizar la carga de documentos desde este dispositivo, es
          necesario que escanees el siguiente código desde la aplicación
          móvil.
        </Typography>
        <Box style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%',
          justifyContent: 'flex-end',
          padding: "1em",
        }}>
          {qrCode != null && !transitionView ?
            <img src={qrCode} alt="qrCode" className={localStyles.qrCode} />
            : <CircularProgress style={{ border: '1em' }} />}
        </Box>
        {/* {!IsDevice().IsMobile && (
          <div className={localStyles.footer}>
            <Typography variant="subtitle2" gutterBottom className={localStyles.footerText} >{packageJson.copyright} Versión: {packageJson.version}</Typography>
          </div>
        )} */}
      </GenericContainerCenter>
    </GenericContainer>);
}
